import { Typography } from '@mui/material';
import styled from 'styled-components';

export const ThumbnailOverlay = styled.div`
  align-items: center;
  color: red;
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  &:before {
    background: #fff;
    content: '';
    display: block;
    height: 20px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    z-index: 1;
  }

  svg {
    height: auto;
    position: relative;
    transition: transform 250ms ease-out;
    width: 25%;
    z-index: 2;
  }
`;

export const ArticleItemWrap = styled.article<{
  compact?: boolean;
  noBorder?: boolean;
}>`
  display: flex;
  gap: 1.25rem;
  position: relative;
  max-width: 100%;

  .YourHighlightClass {
    font-weight: bold;
  }

  & > .showOnHover {
    visibility: hidden;
  }

  &:hover > .showOnHover {
    visibility: visible;
  }
`;

export const ArticleIconWrap = styled.div`
  color: ${props => props.theme.palette.primary.main};
  padding-top: 0.25rem;
`;

export const Title = styled(Typography)<{
  variant: string;
  component: string;
}>`
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  font-size: 1.25rem;

  a {
    color: black;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Description = styled.p`
  /* color: #808080; */
  margin: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: 90%;
`;

export const FloatingBox = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  gap: 0.5rem;
`;

export const CopyButton = styled.div`
  background: ${({ theme }) => theme.palette.primary.main};
  border-radius: 50%;
  color: white;
  font-size: 0.75rem;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    opacity: 0.8;
  }
`;
